import { Button, ButtonStack } from "@arp/react-ndbx";
import React from "react";
import { Application, URLS } from "../../config/const/enums";
import CallIcon from "@mui/icons-material/Call";

export function RetrieveOnlineButtonStack({
  backToQuotePoint,
  showCallButton,
}) {
  return (
    <ButtonStack>
      <Button
        variant="contained"
        color="secondary"
        type="button"
        onClick={() => (window.location.href = URLS.ALLIANZ_HOMEPAGE)}
      >
        CONTINUE TO ALLIANZ WEBSITE
      </Button>
      {showCallButton ? (
        <Button
          variant="contained"
          color="primary"
          type="button"
          href={URLS.CONTACT_US_PHONE_URL}
        >
          <CallIcon sx={{ marginRight: 1, fontSize: "18px" }} />
          {URLS.CONTACT_US_PHONE_NUMBER}
        </Button>
      ) : (
        <Button
          variant="contained"
          color="primary"
          type="button"
          onClick={() => backToQuotePoint(Application.ONLINE)}
        >
          Restart Application
        </Button>
      )}
    </ButtonStack>
  );
}
